import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const RowWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3vw;
  ${bp('sm')`
    grid-template-columns: 1fr;
  `}
`

export const DescriptionWrapper = styled.div<any>`
  .content-wrapper {
    > div {
      p {
        margin-top: 0;
      }
    }
  }

  .featured__wrapper {
    padding: 3px 0;
    break-inside: avoid;
    margin-bottom: 20px;
    margin-right: 15px;

    h4 {
      text-align: center;
      font-weight: 500;
      margin-top: 0;
    }

    ul {
      display: flex;
      justify-content: center;
    }

    li {
      max-width: 110px;
      margin: 0 16px;

      svg {
        background: ${props => props.theme.palette.general.strong};
        fill: ${props => props.theme.palette.general.light};

        * {
          stroke: ${props => props.theme.palette.general.light};
        }
      }
    }
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  tr {
    &:nth-child(odd) {
      background: ${props => props.theme.palette.general.greyExtraLight};
    }
  }

  td {
    padding: 10px 16px;
    ${bp('sm')`
      text-align: center;
    `}

    &:last-of-type {
      color: ${props => props.theme.palette.general.greyMed};
    }
  }
`

export const Drops = styled.div<any>`
  display: flex;
  ${bp('sm')`
    justify-content: center;
  `}

  svg {
    fill: ${props => props.theme.palette.primary.gamma};
    width: 15px;
    height: 15px;
  }
`
